import BaseModel from "./Abstracts/BaseModel";

export default class CoursePage extends BaseModel{
    constructor(data) {
        super()
        this.$dirty = false
        this.id = null
        this.title = ''
        this.position = 99
        this.urls = {}
        this.tokens = {}
        this.content = {data: []}
        this.systemCreated = false
        this._isNewRecord = false
        this.seoMeta = {
            data: {
                title: '',
                description: '',
            }
        }

        this._skipKeys.push('_isNewRecord')
        this._skipKeys.push('urls')
        this._skipKeys.push('tokens')
        this._skipKeys.push('content')
        this._skipKeys.push('seoMeta')

        this.setData(data)
        this.setInitialized()

        this._getAdditionalFormData = function() {
            return {
                metaTitle: this.seoMeta.data.title,
                metaDescription: this.seoMeta.data.description,
            }
        }
    }

    setIsNewRecord() {
        this._isNewRecord = true
        this.id = ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
            (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
        )
    }

    isNewRecord() {
        return this._isNewRecord
    }
}
